import React from 'react';

import { useTemplateStudioState } from 'state/hooks/template-studio.hook';
import { TemplateStudioBlock } from 'state/template-studio.state.service';

import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

export const TemplateStudioTriggeredPopupsForm: React.FC = () => {
  const { setOpenSecondarySidebarBlock, openSecondarySidebarBlock } =
    useTemplateStudioState();

  const toggleSecondarySidebar = (block: TemplateStudioBlock) => {
    setOpenSecondarySidebarBlock(undefined);
    if (openSecondarySidebarBlock !== block) {
      setTimeout(() => {
        setOpenSecondarySidebarBlock(block);
      }, 100);
    }
  };

  return (
    <div className="flex gap-2 mt-2 justify-between">
      <div className="text-sm">Element Type</div>
      <Tabs defaultValue="widget" orientation="vertical">
        <TabsList className="flex-col bg-base-muted h-[76px]">
          <TabsTrigger
            value="widget"
            // onClick={() =>
            //   toggleSecondarySidebar(StoreBodyBlock.triggeredPopups)
            // }
            className="h-[34px] w-[120px] data-[state=active]:bg-base-background data-[state=active]:text-indigo-500 text-base-mutedForeground"
          >
            Widget
          </TabsTrigger>
          <TabsTrigger
            value="popup"
            // onClick={() => toggleSecondarySidebar('popup')}
            className="h-[34px] w-[120px] data-[state=active]:bg-base-background data-[state=active]:text-indigo-500 text-base-mutedForeground"
          >
            Popup
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};
